import { BrowserRouter, Route, Routes } from "react-router-dom";
import React, { useEffect } from "react";
import "./App.css";
import Home from "./Component/Home/Home";
import CompanyOverview from "./Component/WhoweAre/CompanyOverview/CompanyOverview";
import HowWeWork from "./Component/WhoweAre/HowWeWork/HowWeWork";
import LifeAtWeb from "./Component/WhoweAre/LifeAtWeb/LifeAtWeb";
import Careers from "./Component/WhoweAre/Careers/Careers";
import ContactUs from "./Component/WhoweAre/ContectUs/ContactUs";
import Services from "./Component/Services/Service";
import MobileApp from "./Component/Services/MobileApp/MobileApp";
import WebDevelopment from "./Component/Services/WebDevelopment/WebDevelopment";
import Iot from "./Component/Services/Iot/Iot";
import Uiux from "./Component/Services/Uiux/Uiux";
import DedicatedDev from "./Component/Services/DedicatedDev/DedicatedDev";
import IndusAutomation from "./Component/Services/IndusAutomation/IndusAutomation";
import Blog from "./Component/Blog/Blog";
import Indus from "./Component/Industries/Indus";
import D2C from "./Component/Industries/D2C/D2C";
import Ai from "./Component/Ai/Ai";
import Portfolio from "./Component/Portfolio/Portfolio";
import ECom from "./Component/Industries/ECom/ECom";
import Logistic from "./Component/Industries/Logistic/Logistic";
import Fintech from "./Component/Industries/Fintech/Fintech";
import Card1 from "./Component/Blog/Cards/Card1/Card1";
import ScrollToTop from "./ScrollToTop";
import TermConditions from "./Component/Footer/TermConditions";
import PrivacyPolicy from "./Component/Footer/PrivacyPolicy";
import InnerPortfolio from "./Component/Portfolio/Second_section/InnerPage/InnerPortfolio";
import Testimonials from "./Component/Home/Ourclientword/Testimoni/Testimonials";

function App() {
  useEffect(() => {
    // Set the default primary color on app load
    document.documentElement.style.setProperty("--primary-color", "#21aae9");
  }, []);

  return (
    <>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/CompanyOverview" element={<CompanyOverview />} />
          <Route path="/howweWork" element={<HowWeWork />} />
          <Route path="/lifeAtWeb" element={<LifeAtWeb />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/ContactUs" element={<ContactUs />} />
          <Route path="/Services" element={<Services />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/indus" element={<Indus />} />
          <Route path="/ai" element={<Ai />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/indus/d2c" element={<D2C />} />
          <Route path="/indus/eCommerce" element={<ECom />} />
          <Route path="/indus/logistic" element={<Logistic />} />
          <Route path="/indus/fintech" element={<Fintech />} />
          <Route path="/Services/mobileApp" element={<MobileApp />} />
          <Route path="/Services/webDevelopment" element={<WebDevelopment />} />
          <Route path="/Services/Iot" element={<Iot />} />
          <Route path="/Services/uiUx" element={<Uiux />} />
          <Route path="/term&conditions" element={<TermConditions />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route
            path="/Services/dedicatedDevelopers"
            element={<DedicatedDev />}
          />
          <Route
            path="/Services/indusAutomation"
            element={<IndusAutomation />}
          />
          <Route path="/Blog/Card1" element={<Card1 />} />
          <Route
            path="/Portfolio/InnerPortfolio"
            element={<InnerPortfolio />}
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
